<script setup lang="ts">
import { useAppNavigation } from '@/composables/useAppNavigation'
import { usePlatform } from '@/composables/usePlatform'
const { items } = useAppNavigation()
const { isNative } = usePlatform()
</script>

<template>
  <nav class="app-navigation" :class="{ 'app-navigation--web': !isNative }" :aria-label="$t('main_navigation')">
    <router-link to="/services" class="navigation-brand" aria-label="Donna Bella">
      <img src="/new-logo.png" alt="Donna Bella" width="150" /><span>Brauweg 81 · Göttingen</span>
    </router-link>
    <router-link v-for="item in items" :key="item.path" :to="item.path" class="navigation-item" :class="{ active: item.active }" :aria-current="item.active ? 'page' : undefined">
      <i :class="`fi fi-${item.active ? 'sr' : 'rr'}-${item.icon}`" aria-hidden="true"></i><span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<style scoped>
.app-navigation { position: fixed; inset: auto 0 0; height: calc(var(--app-nav-height) + var(--app-safe-bottom)); padding: 0 var(--app-safe-right) var(--app-safe-bottom) var(--app-safe-left); background: #fffffff5; backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-top: 1px solid var(--app-border); display: grid; grid-auto-flow: column; grid-auto-columns: 1fr; z-index: 1000; }
.navigation-brand { display: none; }
.navigation-item { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; margin: 4px; border-radius: 14px; color: var(--app-muted); font-size: 12px; font-weight: 500; line-height: 1.2; min-height: 56px; }
.navigation-item i { display: grid; place-items: center; width: 46px; height: 28px; border-radius: 11px; font-size: 22px; }
.navigation-item.active { background: var(--app-accent-soft); color: var(--app-accent-ink); font-weight: 650; }
.navigation-item:active { opacity: .65; }
@media (min-width: 960px) and (min-height: 600px) {
  .app-navigation--web { inset: 0 auto 0 0; width: var(--app-sidebar-width); height: 100dvh; padding: 0 12px 20px; display: flex; flex-direction: column; gap: 4px; background: white; border: 0; border-right: 1px solid var(--app-border); }
  .app-navigation--web .navigation-brand { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; padding: 24px 12px 32px; color: var(--app-muted); }
  .navigation-brand span { font-size: 12px; }
  .app-navigation--web .navigation-item { flex-direction: row; justify-content: flex-start; min-height: 46px; margin: 0; padding: 0 14px; gap: 14px; font-size: 14px; border-radius: 8px; }
  .app-navigation--web .navigation-item i { width: 24px; font-size: 20px; }
  .app-navigation--web .navigation-item.active { background: var(--app-accent-soft); }
  .app-navigation--web .navigation-item:hover { background: #fff8f1; }
}
</style>
